import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BankRequisite } from '../../../BankRequisite';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { padNumber, prettyFloatMoney, scrollTop } from '@/helpers/utils';
import s from './index.module.scss';

export const BankTransfer = ({ amount }) => {
  const { profile } = useGetMe();
  const { t } = useTranslation('cash');

  useEffect(() => {
    scrollTop();
  }, []);

  if (!profile) return null;

  return (
    <>
      <h1 className={classnames(s.bank_transfer__title, 'f-26 f-500')}>
        {t('bank_transfer.add_cash_to_account')}
      </h1>
      <div className={s.bank_transfer__total}>
        <div className={classnames(s.bank_transfer__total_label, 'f-16-24 f-400')}>
          {t('bank_transfer.payment_amount')}
        </div>
        <div className={classnames(s.bank_transfer__total_amount, 'f-42 f-500')}>
          {prettyFloatMoney(amount)}
        </div>
      </div>

      <p className={classnames(s.bank_transfer__desc, 'f-16 f-400')}>
        {t('bank_transfer.transfer_cash_description')}
      </p>

      <div className={s.bank_transfer__container}>
        <BankRequisite userID={profile?.id} className={s.bank_transfer__req} />
        <div className={s.bank_transfer__req_desc}>
          <p>{t('bank_transfer.currency_info')}</p>
          <p>
            {t('bank_transfer.cash_acceptance_info', {
              companyName: profile?.company?.name ? `: ${profile.company.name}` : '.',
            })}
          </p>
          <p>{t('bank_transfer.cash_arrival_time')}</p>
          <p>
            {t('bank_transfer.founder_id_reminder')}{' '}
            <span className="f-500">{padNumber(profile.id)}</span>
          </p>
        </div>
      </div>
    </>
  );
};
